import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIosComponent } from './simple-icons-ios.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIosComponent ],
    exports:      [ SimpleIconsIosComponent ],
    bootstrap:    []
})
export class SimpleIconsIosModule {}
